import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { clearSelectedPartAction, updatePartAction } from '../../../redux/actions/partsActions';
import Button from '../../shared/buttons/Button';
import Modal from '../../shared/modal/Modal';
import PartForm from '../forms/PartForm';

const UpdatePartModal = ({ readOnly, onModalClose, onModalSubmit }) => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const part = useSelector((state) => state.parts?.part);

  const onSubmit = async (data) => {
    setLoading(true);
    await dispatch(updatePartAction(data));
    await dispatch(clearSelectedPartAction());
    setLoading(false);
    onModalSubmit();
  };

  return (
    <Modal
      title={'Змінити деталь'}
      loading={loading}
      onClose={onModalClose}
      body={<PartForm readOnly={readOnly} onSubmit={onSubmit} loading={loading} initPart={part} />}
      actionButton={
        !readOnly && (
          <Button type={'submit'} disabled={loading} variant={'primary'} formId={'part-form'} children={'Змінити'} />
        )
      }
    />
  );
};

export default UpdatePartModal;
